const AlertTransactionEdit = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M10.3702 1.92223C11.0862 1.20626 12.247 1.20626 12.9629 1.92222L14.0773 3.03661C14.7933 3.75257 14.7933 4.91337 14.0773 5.62933L12.5403 7.1664L8.83325 3.4594L8.12614 4.1665L11.8332 7.87351L5.57733 14.1293C5.23351 14.4731 4.7672 14.6663 4.28097 14.6663H1.83325C1.55711 14.6663 1.33325 14.4424 1.33325 14.1663V11.7186C1.33325 11.2324 1.52641 10.766 1.87022 10.4222L10.3702 1.92223Z"
      fill="currentColor"
    />
  </svg>
)

export default AlertTransactionEdit
